const constructionsLang = {
  menuTitle: 'Chantiers',
  myPlanning: 'Mon planning',

  terms: {
    chantierOne: 'chantier',
    chantierMore: 'chantiers',
    planningOne: 'planification',
    planningMore: 'planifications',
    technicianOne: 'technicien',
    technicianMore: 'techniciens',
  },

  planification: {
    tabTitle_n: '{term}',
    tabTitle_m: '{term}',
    tabTitle_f: '{term}',
    empty_n: 'Aucun {term}',
    empty_m: 'Aucun {term}',
    empty_f: 'Aucune {term}',
    newTitle_n: 'Nouvel {term}',
    newTitle_m: 'Nouveau {term}',
    newTitle_f: 'Nouvelle {term}',
    editTitle_n: 'Modification de l\'{term}',
    editTitle_m: 'Modification du {term}',
    editTitle_f: 'Modification de la {term}',
    status: {
      1: 'À faire',
      2: 'Terminée'
    },
    nbTechncianRequired_n: 'Nombre d\'{term} nécessaires',
    nbTechncianRequired_m: 'Nombre de {term} nécessaires',
    nbTechncianRequired_f: 'Nombre de {term} nécessaires',
    duration_n: 'Durée de l\'{term}',
    duration_m: 'Durée du {term}',
    duration_f: 'Durée de la {term}'
  },

  construction: {
    menu_n: 'Liste des {term}',
    menu_m: 'Liste des {term}',
    menu_f: 'Liste des {term}',
    menuAddTitle_n: 'Créer un {term}',
    menuAddTitle_m: 'Créer un {term}',
    menuAddTitle_f: 'Créer une {term}',
    title_n: '{term} n°{reference}',
    title_m: '{term} n°{reference}',
    title_f: '{term} n°{reference}',
    pdf_n: 'Fiche {term}',
    pdf_m: 'Fiche {term}',
    pdf_f: 'Fiche {term}',
    newTitle_n: 'Nouvel {term}',
    newTitle_m: 'Nouveau {term}',
    newTitle_f: 'Nouvelle {term}',
    editTitle_n: 'Modification de l\'{term} n°{reference}',
    editTitle_m: 'Modification du {term} n°{reference}',
    editTitle_f: 'Modification de la {term} n°{reference}',
    myMenu_n: 'Mes {term}',
    myMenu_m: 'Mes {term}',
    myMenu_f: 'Mes {term}',
    deleteMsg_n: 'Êtes-vous sûr de vouloir supprimer cette {term} ?',
    deleteMsg_m: 'Êtes-vous sûr de vouloir supprimer ce {term} ?',
    deleteMsg_f: 'Êtes-vous sûr de vouloir supprimer cette {term} ?',
    statusEdit_n: 'statut de l\'{term}',
    statusEdit_m: 'statut du {term}',
    statusEdit_f: 'statut de la {term}',
    form: {
      infosTitle_n: 'Informations sur l\'{term}',
      infosTitle_m: 'Informations sur le {term}',
      infosTitle_f: 'Informations sur la {term}',
      title_n: 'Titre de l\'{term}',
      title_m: 'Titre du {term}',
      title_f: 'Titre de la {term}',
      address_n: 'Adresse de l\'{term}',
      address_m: 'Adresse du {term}',
      address_f: 'Adresse de la {term}',
      contents_n : 'Contenu de l\'{term}',
      contents_m : 'Contenu du {term}',
      contents_f : 'Contenu de la {term}',
      contentsEmpty_n: 'L\'{term} ne contient aucune ligne',
      contentsEmpty_m: 'Le {term} ne contient aucune ligne',
      contentsEmpty_f: 'La {term} ne contient aucune ligne'
    },
    list: {
      refererence_n: 'N°{term}',
      refererence_m: 'N°{term}',
      refererence_f: 'N°{term}'
    },
    status: {
      1: 'À planifier',
      2: 'Planifié partiellement',
      3: 'Planifié',
      4: 'Terminé'
    },
    invoiceStatus: {
      1: 'À facturer',
      2: 'Facturé partiellement',
      3: 'Facturé'
    },
    planning: {
      menu_n: 'Planning des {term}',
      menu_m: 'Planning des {term}',
      menu_f: 'Planning des {term}',
    }
  },
  params: {
    menu: 'Paramètres',
    pageTitle: 'Configuration des chantiers'
  },
  materials: {
    label: 'matériel',
    reference: 'Référence',
    name: 'Nom du matériel',
    new: 'Créer un matériel',
    edit: 'Modifier un matériel',
    deleteMsg: 'Êtes-vous sûr de supprimer ce matériel ?'
  },
  technicals: {
    label: 'technicien',
    name: 'Nom du technicien',
    email: 'Email',
    new: 'Créer un technicien',
    edit: 'Modifier un technicien',
    deleteMsg: 'Êtes-vous sûr de supprimer ce technicien ?'
  }
}

export default {
  constructions: constructionsLang,
  tasks: {
    searchTypes: {
      construction: 'Chantier'
    }
  },
  calendars: {
    searchTypes: {
      construction: 'Chantier'
    }
  }
}
